

























































































































import { Component, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { refsService } from '@/app/shared/refs.service';
import { AttemptModel, TransactionModel } from '@/app/shared/models';
@Component
export default class DataTableAttemptsComponent extends Vue {
  private headers: DataTableHeader[] = [];
  private headersTransaction: DataTableHeader[] = [];
  private loading = true;

  private get refs() {
    return refsService;
  }
  private get attemptList(): AttemptModel[] {
    return this.refs.modules.contract.attemptList;
  }
  private get transactionList(): TransactionModel[] {
    return this.refs.modules.contract.transactionList;
  }

  private created(): void {
    this.headers = [
      { text: this.$t('headers.attempts_number').toString(), value: 'Number' },
      {
        text: this.$t('headers.execution_date').toString(),
        value: 'ExecutionDate',
      },
      {
        text: this.$t('headers.attempt_type').toString(),
        value: 'Type',
      },
      {
        text: this.$t('headers.transaction_date').toString(),
        value: 'LastTransaction.Date',
      },
      {
        text: this.$t('headers.route_name').toString(),
        value: 'RouteName',
      },
      {
        text: this.$t('headers.status').toString(),
        value: 'Status',
      },
      {
        text: this.$t('-').toString(),
        value: 'LastTransaction',
      },
      { text: '', value: 'data-table-expand', sortable: false },
    ];
    this.headersTransaction = [
      { text: '', value: 'data-table-expand', sortable: false },
      { text: this.$t('headers.status').toString(), value: 'Status' },
      { text: this.$t('headers.covenant').toString(), value: 'Covenant' },
      { text: this.$t('headers.return').toString(), value: 'Return' },
      { text: this.$t('headers.message').toString(), value: 'Message' },
      { text: this.$t('headers.nsu').toString(), value: 'Nsu' },
      { text: this.$t('headers.tid').toString(), value: 'Tid' },
      {
        text: this.$t('headers.authorization').toString(),
        value: 'AuthorizationCode',
      },
      {
        text: this.$t('labels.credit_card_number').toString(),
        value: 'PaymentMethod',
      },
      {
        text: this.$t('labels.value').toString(),
        value: 'Value',
      },
      { text: '', value: 'data-table-expand', sortable: false },
    ];
  }
  private async loadTransactionList(dataItem: {
    item: AttemptModel;
    value: boolean;
  }) {
    if (dataItem.value) {
      this.loading = true;
      await this.refs.modules.contract
        .loadTransactionList({
          contractId: this.refs.modules.contract.contract.Id,
          installmentId: this.refs.modules.contract.installment.Id,
          attemptId: dataItem.item.Id,
        })
        .catch((err) => this.$toast.error('ERROR ? ', err))
        .finally(() => {
          this.loading = false;

          if (this.refs.modules.contract.transactionList.length > 0) {
            let canClear = false;
            let isDebit = false;
            this.refs.modules.contract.transactionList.forEach((element) => {
              if (
                this.refs.enums.PaymentMethod[element.PaymentMethod] ==
                  this.refs.enums.PaymentMethod.BankSlip.toString() ||
                this.refs.enums.PaymentMethod[element.PaymentMethod] ==
                  this.refs.enums.PaymentMethod.BRCode.toString()
              ) {
                canClear = true;
              }
              if (
                this.refs.enums.PaymentMethod[element.PaymentMethod] ==
                this.refs.enums.PaymentMethod.Debit.toString()
              ) {
                isDebit = true;
              }
            });
            if (canClear) {
              if (this.headersTransaction.length > 8) {
                this.headersTransaction.splice(5, 1);
                this.headersTransaction.splice(5, 1);
                this.headersTransaction.splice(5, 1);
              }
            } else if (isDebit) {
              if (this.headersTransaction.length >= 8) {
                this.headersTransaction.splice(5, 1);
                this.headersTransaction.splice(5, 1);
                this.headersTransaction.splice(5, 1);
                this.headersTransaction.splice(5, 0, {
                  text: this.$t('headers.Output').toString(),
                  value: 'Output',
                });
                this.headersTransaction.splice(5, 0, {
                  text: this.$t('headers.Input').toString(),
                  value: 'Input',
                });
              }
            } else {
              if (this.headersTransaction.length < 8) {
                this.headersTransaction.splice(5, 0, {
                  text: this.$t('headers.authorization').toString(),
                  value: 'AuthorizationCode',
                });
                this.headersTransaction.splice(5, 0, {
                  text: this.$t('headers.nsu').toString(),
                  value: 'Nsu',
                });
                this.headersTransaction.splice(5, 0, {
                  text: this.$t('headers.tid').toString(),
                  value: 'Tid',
                });
              }
            }
          }
        });
    }
  }

  private paymentInfo(transcation: TransactionModel) {
    if (
      this.refs.enums.PaymentMethod[transcation.PaymentMethod] ==
        this.refs.enums.PaymentMethod.BankSlip.toString() ||
      this.refs.enums.PaymentMethod[transcation.PaymentMethod] ==
        this.refs.enums.PaymentMethod.BRCode.toString()
    )
      return this.refs.static.enumDescriptions.get2(
        this.refs.enums.PaymentMethod,
        transcation.PaymentMethod
      );
    else return transcation.CardTruncatedNumber;
  }
}
